import { render, staticRenderFns } from "./OverallStat.vue?vue&type=template&id=8160af2e"
import script from "./OverallStat.vue?vue&type=script&lang=js"
export * from "./OverallStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports